document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile nav drawer ---------- */
  var burger = document.querySelector('[data-mobile-nav-open]');
  var closeBtn = document.querySelector('[data-mobile-nav-close]');
  var drawer = document.querySelector('[data-mobile-nav]');
  var overlay = document.querySelector('[data-mobile-nav-overlay]');

  function toggleNav(open) {
    if (!drawer || !overlay) return;
    drawer.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger) burger.addEventListener('click', function () { toggleNav(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { toggleNav(false); });
  if (overlay) overlay.addEventListener('click', function () { toggleNav(false); });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty-input]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input');
    var minus = wrapper.querySelector('[data-qty-minus]');
    var plus = wrapper.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(0, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full-src');
      var mainImg = document.querySelector('[data-product-main-image]');
      if (mainImg && full) mainImg.src = full;
      document.querySelectorAll('[data-product-thumb]').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Variant selection: swatches pick the matching variant ---------- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function syncVariant(form) {
    if (!form) return;
    var jsonEl = form.querySelector('[data-product-json]') || document.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var selected = [];
    form.querySelectorAll('[data-swatch-group]').forEach(function (group) {
      var s = group.querySelector('[data-swatch].is-selected');
      selected.push(s ? s.getAttribute('data-value') : null);
    });

    var match = null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var ok = true;
      for (var j = 0; j < selected.length; j++) {
        if (v.options[j] !== selected[j]) { ok = false; break; }
      }
      if (ok) { match = v; break; }
    }

    var select = form.querySelector('select[name="id"]');
    var submitBtn = form.querySelector('[type="submit"]');
    var priceEl = document.querySelector('[data-product-price]');

    if (match) {
      if (select) select.value = String(match.id);
      if (priceEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceEl.innerHTML = '<span class="compare">' + formatMoney(match.compare_at_price) + '</span> <span class="sale">' + formatMoney(match.price) + '</span>';
        } else {
          priceEl.innerHTML = '<span>' + formatMoney(match.price) + '</span>';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }
    } else if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Unavailable';
    }
  }

  document.querySelectorAll('[data-swatch]').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      var group = swatch.closest('[data-swatch-group]');
      if (group) {
        group.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-selected'); });
      }
      swatch.classList.add('is-selected');
      syncVariant(swatch.closest('form'));
    });
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) { syncVariant(form); });

  /* ---------- Accordion (native <details>, no JS required) ---------- */

  /* ---------- Cart count badge refresh helper ---------- */
  window.usaVinylsUpdateCartCount = function (count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  };

  /* ---------- AJAX add-to-cart (progressive enhancement) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          window.usaVinylsUpdateCartCount(cart.item_count);
          if (submitBtn) { submitBtn.textContent = 'Added ✓'; }
          setTimeout(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
          }, 1500);
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
          form.submit(); // fallback to normal form submission
        });
    });
  });

});
